module.exports = __webpack_public_path__ + "static/Montserrat-Light-hint-all-fa9171d1c1ad4ead9e2389584dc67f1c.woff2";